import { render, staticRenderFns } from "./RelationTask.vue?vue&type=template&id=fb11bdc0&scoped=true&"
import script from "./RelationTask.vue?vue&type=script&lang=js&"
export * from "./RelationTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb11bdc0",
  null
  
)

export default component.exports